import { render, staticRenderFns } from "./CLtkAvatar.vue?vue&type=template&id=3de3e9e2"
import script from "./CLtkAvatar.vue?vue&type=script&lang=ts"
export * from "./CLtkAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CImage/CImage.vue').default,CAvatar: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CAvatar/CAvatar.vue').default})
